/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import {
    ApiError400DefaultCodeEnum,
    ApiError404DefaultCodeEnum,
    ApiError500DefaultCodeEnum,
} from 'client-code/actions';

import { AppError } from './AppError';
import { ErrorTypes } from './ErrorTypes';

export class ContentScreenDetailsError extends AppError {
    public constructor(code: string, message: string) {
        super(code, message);
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case ApiError400DefaultCodeEnum.ApigwError:
                this.type = ApiError400DefaultCodeEnum.ApigwError;
                this.code = ErrorTypes.CONTENT_SCREEN_DETAILS_1901;
                break;
            case ApiError400DefaultCodeEnum.BadRequest:
                this.type = ApiError400DefaultCodeEnum.BadRequest;
                this.code = ErrorTypes.CONTENT_SCREEN_DETAILS_1902;
                break;
            case ApiError404DefaultCodeEnum.ResourceNotFound:
                this.type = ApiError404DefaultCodeEnum.ResourceNotFound;
                this.code = ErrorTypes.CONTENT_SCREEN_DETAILS_1903;
                break;
            case ApiError500DefaultCodeEnum.InternalServerError:
                this.type = ApiError500DefaultCodeEnum.InternalServerError;
                this.code = ErrorTypes.CONTENT_SCREEN_DETAILS_1904;
                break;
            default:
                this.type = 'CONTENT_SCREEN_DETAILS_UNKNOWN_ERROR';
                this.code = ErrorTypes.CONTENT_SCREEN_DETAILS_1999;
        }
    }
}
